'use strict';
/**
 * @type {Object}
 * @property {Object} NOT_FOUND generic not found error code for whole user service
 */
var serviceErrorCodes = Object.freeze({
    NOT_FOUND                      : 'groupService.notFound',
    PERMISSION_DENIED              : 'groupService.permissionDenied',
    GROUP_ALREADY_EXISTS           : 'groupService.groupAlreadyExists',
    INVITATION_NOT_FOUND           : 'groupService.invitationNotFound',
    CANT_JOIN_CLOSED_GROUP         : 'groupService.cantJoinClosedGroup',
    JOIN_REQUEST_NOT_FOUND         : 'groupService.joinRequestNotFound',
    USER_ALREADY_MEMBER            : 'groupService.userAlreadyMember',
    NOT_MEMBER                     : 'groupService.notMember',
    CANT_BLOCK_MEMBER              : 'groupService.cantBlockMember',
    USER_NOT_FOUND                 : 'groupService.userNotFound',
    USER_ALREADY_APPLIED           : 'groupService.userAlreadyApplied',
    CANT_ADD_BLOCKED_USER          : 'groupService.cantAddBlockedUser',
    TAG_ALREADY_EXISTS             : 'groupService.tagAlreadyExists',
    POST_NOT_FOUND                 : 'groupService.postNotFound',
    USER_ALREADY_INVITED           : 'groupService.userAlreadyInvited',
    GROUP_BLOCKED_BY_USER          : 'groupService.groupBlockedByUser',
    CANT_KICK_YOURSELF             : 'groupService.cantKickYourself',
    CANT_KICK_OWNER                : 'groupService.cantKickOwner',
    NO_ROLE_SPOT_AVAILABLE         : 'groupService.noRoleSpotAvailable',
    USER_NOT_BLOCKED               : 'groupService.userNotBlocked',
    CANT_BLOCK_GROUP_YOU_ARE_MEMBER: 'groupService.cantBlockGroupYouAreMember',
    GROUP_NOT_BLOCKED              : 'groupService.groupNotBlocked',
    ROLE_NOT_FOUND                 : 'groupService.roleNotFound',
    FRIEND_REQUEST_NOT_FOUND       : 'groupService.friendRequestNotFound',
    ALREADY_FRIENDS                : 'groupService.alreadyFriends',
    FRIEND_REQUEST_ALREADY_EXISTS  : 'groupService.friendRequestAlreadyExists',
    FRIEND_REQUEST_REJECTED        : 'groupService.friendRequestRejected',
    FRIEND_REQUEST_NOT_ACCEPTED    : 'groupService.friendRequestNotAccepted',
    FRIEND_REQUEST_ALREADY_ACCEPTED: 'groupService.friendRequestAlreadyAccepted',
    FRIEND_REQUEST_ALREADY_REJECTED: 'groupService.friendRequestAlreadyRejected',
    FRIEND_REQUEST_LIMIT_REACHED   : 'groupService.friendRequestLimitReached',
    CANT_CREATE_FRIEND             : 'groupService.cantCreateFriend',
    CANT_UPDATE_FRIEND             : 'groupService.cantUpdateFriend',
    FRIEND_NOT_FOUND               : 'groupService.friendNotFound',
    FRIEND_LIMIT_REACHED           : 'groupService.friendLimitReached',
    USER_NOT_IN_BLOCK_LIST         : 'groupService.userNotInBlockList',
    USER_BLOCKED                   : 'groupService.userBlocked',
    GROUP_NOT_FOUND                : 'groupApi.groupNotFound',
    APPLICATION_NOT_FOUND          : 'groupApi.applicationNotFound',
    APPLICATION_ALREADY_EXISTS     : 'groupApi.applicationAlreadyExists',
    INVITATION_ALREADY_EXISTS      : 'groupApi.invitationAlreadyExists',
    GROUP_ALREADY_BLOCKED          : 'groupApi.groupAlreadyBlocked',
    USER_ALREADY_BLOCKED           : 'groupApi.userAlreadyBlocked',
    ALREADY_MEMBER                 : 'groupApi.alreadyMember',
    GROUP_LIMIT                    : 'groupApi.groupLimit',
    USER_NOT_OWNER                 : 'groupApi.userNotOwner',
    GROUP_NOT_JOINABLE             : 'groupApi.groupNotJoinable',
    CANT_REMOVE_OWNER              : 'groupApi.cantRemoveOwner',
    USER_NOT_MEMBER                : 'groupApi.userNotMember',
});

module.exports = serviceErrorCodes;